"use Client"
import { List } from "@mui/material"
import { MenuIcons } from "@tc/ui-dfe/utils/constants/iconMaps"
import { usePermission } from "@tc/ui-permission/hooks"
import type { Route } from "@tc/ui-permission/utils"
import { usePathname } from "next/navigation"
import { MenuItem } from "./MenuItem"
interface ReduceChildRoutesProps {
  list: React.ReactNode[]
  item: Route
  path: string
  ffPath?: Record<string, string>
  hasFeatureFlags: (featureFlags: string[]) => boolean
  onClose?: () => void
  onModalOpen?: () => void
}
interface MenuProps {
  routes: readonly Route[]
  onClose?: () => void
  onModalOpen?: () => void
}
const reduceChildRoutes = ({
  list,
  item,
  path,
  ffPath,
  hasFeatureFlags,
  onClose,
  onModalOpen,
}: ReduceChildRoutesProps) => {
  const key = `${item.path}`
  const partialMatch =
    path.substring(1).split("/", 2).includes(item.path.substring(1)) &&
    path.substring(1).split("/", 2).at(0) === item.path.split("/").at(1) // this will check if the first path is the same and check if all other subpaths are in the item.path
  const exactMatch = path === item.path

  if (hasFeatureFlags(item.featureFlags as string[])) {
    list.push(
      <MenuItem
        key={key}
        active={exactMatch || partialMatch}
        label={item.label}
        path={item.path}
        icon={MenuIcons[item.path as keyof typeof MenuIcons]}
        open={partialMatch}
        onClose={onClose}
        access={item.access}
        ffPath={ffPath}
        isModal={item.isModal}
        onModalOpen={onModalOpen}
      />,
    )
  }
  return list
}
export const Menu = ({ routes, onClose, onModalOpen }: MenuProps) => {
  const path = usePathname()
  const { hasPermission } = usePermission()
  return (
    <List component="div" data-testid="test-menu">
      {routes.reduce(
        (list: React.ReactNode[], item: Route) =>
          reduceChildRoutes({
            list,
            item,
            path,
            ffPath: item.ffPath,
            hasFeatureFlags: hasPermission,
            onClose,
            onModalOpen,
          }),
        [],
      )}
    </List>
  )
}
